export default "__VITE_ASSET__LZN0WJeU__"